export default __webpack_public_path__ + "static/media/Medium-Symbol-Black-RGB@4x.7dfaa3c7.png";